import type {ScheduleCostAvoidance} from '@domain/schedule'
import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery, useQueryClient} from '@tanstack/react-query'

export const SCHEDULE_COST_AVOIDANCE_QUERY_KEY = 'scheduleCostAvoidance'

export const fetchScheduleCostAvoidance = async (
  plantCode: string,
  scheduleId: number,
  signal?: AbortSignal
): Promise<ScheduleCostAvoidance> => {
  const response = await ApiClient.axiosInstance.get<ScheduleCostAvoidance>(
    `/plants/${plantCode}/schedules/${scheduleId}/kpi/cost-avoidance`,
    {signal}
  )
  return response.data
}

export const useScheduleCostAvoidanceQuery = (scheduleId: number) => {
  const {plantId: plantCode} = useUpmPlantContext()
  const queryClient = useQueryClient()

  // this query is always disabled, it returns only available data in cache
  const query = useQuery<ScheduleCostAvoidance>({
    queryKey: [SCHEDULE_COST_AVOIDANCE_QUERY_KEY, {plantCode, scheduleId}],
    queryFn: ({signal}) => fetchScheduleCostAvoidance(plantCode, scheduleId, signal),
    enabled: false,
    throwOnError: true,
    // preventing disabled queries from firing during invalidation
    gcTime: 0
  })

  const remove = () =>
    queryClient.removeQueries({
      queryKey: [SCHEDULE_COST_AVOIDANCE_QUERY_KEY, {plantCode, scheduleId}]
    })

  return {...query, remove}
}
